/**
 * Owns the async state for the AI Chat workbench's tools and installed skills.
 * Bootstrap supplies transport and view callbacks so this controller does not
 * depend on the page DOM or a specific API module.
 */
export function createWorkbenchDataController({
  fetchToolCapabilities,
  fetchInstalledSkills,
  renderTools,
  renderSkills,
  syncVisibility,
  logger = console,
} = {}) {
  let toolCapabilities = [];
  let toolsLoadError = false;
  let installedSkills = [];
  let skillsLoadError = false;
  let skillsLoading = false;

  function getWorkspaceState() {
    return {
      installedSkills: installedSkills.length,
      toolCapabilities: toolCapabilities.length,
      skillsLoading,
      skillsError: skillsLoadError,
      toolsError: toolsLoadError,
    };
  }

  function getToolRenderState() {
    return { capabilities: toolCapabilities, loadError: toolsLoadError };
  }

  function getSkillRenderState() {
    return { skills: installedSkills, loading: skillsLoading, loadError: skillsLoadError };
  }

  async function loadToolCapabilities() {
    try {
      toolsLoadError = false;
      toolCapabilities = await fetchToolCapabilities();
      renderTools?.(getToolRenderState());
      syncVisibility?.();
    } catch (error) {
      toolsLoadError = true;
      logger.error?.('[aichat] load tool capabilities failed:', error);
      renderTools?.(getToolRenderState());
    }
  }

  async function loadInstalledSkills(roleCode) {
    skillsLoading = true;
    skillsLoadError = false;
    renderSkills?.(getSkillRenderState());
    syncVisibility?.();
    try {
      installedSkills = await fetchInstalledSkills(roleCode);
    } catch (error) {
      skillsLoadError = true;
      logger.error?.('[aichat] load skills failed:', error);
    } finally {
      skillsLoading = false;
      renderSkills?.(getSkillRenderState());
      syncVisibility?.();
    }
  }

  return Object.freeze({
    getSkillRenderState,
    getToolRenderState,
    getWorkspaceState,
    loadInstalledSkills,
    loadToolCapabilities,
  });
}
